import {
  FETCH_INIT,
  FETCHED,
  FETCHED_FAIL,
  SET_SORTING,
  SET_FILTER,
  CHANGE_PAGE,
  SET_SERVER_PAGE,
  UPDATE_DATA,
  DELETE_ITEM,
} from "../actions/EzuppBlog.action";
import Constants from "../config/constants";

function mapPresetPRequest(all, pageId) {
  const start = pageId * Constants.DEFAULT_PAGE_VALUE;
  return all.slice(start, start + Constants.DEFAULT_PAGE_VALUE);
}

const initialState = {
  all: [],
  present: [],
  currentPage: 0,
  serverPage: 0,
  query: null,
  query_data: null,
  sorting_data: { row: null, order: null },
  is_fetching: false,
};

export default function ezuppBlogReducer(state = JSON.parse(JSON.stringify(initialState)), action) {
  switch (action.type) {
    case FETCH_INIT: {
      return { ...state, is_fetching: true };
    }
    case FETCHED: {
      const { data, page } = action.payload;
      const newAll = page === 1 ? [...data] : [...state.all, ...data];
      return { ...state, all: newAll, present: mapPresetPRequest(newAll, state.currentPage), is_fetching: false };
    }
    case FETCHED_FAIL: {
      return { ...state, is_fetching: false };
    }
    case SET_SORTING: {
      return { ...state, sorting_data: action.payload };
    }
    case SET_FILTER: {
      return { ...state, query: action.payload?.query ?? null, query_data: action.payload?.query_data ?? null };
    }
    case CHANGE_PAGE: {
      return { ...state, present: mapPresetPRequest(state.all, action.payload), currentPage: action.payload };
    }
    case SET_SERVER_PAGE: {
      return { ...state, serverPage: action.payload };
    }
    case UPDATE_DATA: {
      if (!action.payload) return state;
      const newAll = state.all.map((val) => (val.id === action.payload.id ? { ...val, ...action.payload } : val));
      return { ...state, all: newAll, present: mapPresetPRequest(newAll, state.currentPage) };
    }
    case DELETE_ITEM: {
      const newAll = state.all.filter((val) => val.id !== action.payload);
      return { ...state, all: newAll, present: mapPresetPRequest(newAll, state.currentPage) };
    }
    default: {
      return state;
    }
  }
}
